import React from "react";
import { Link } from "react-router-dom";
import EIConnectionViewTable from "./eiConnectionView";
import "../util/tables.css";
import { useDataView } from "../../contexts/data.view.context";
import * as API from "../api/index";
import { NotificationManager } from "react-notifications";
import AppDialog from "../util/appDialog";
import ViewEditConnection from "./viewEditConnection";
import ShowLoadingBar from "../util/showLoadingBar";
import { makeEnvCellRenderer } from "../shared/makeEnvCellRenderer";
import SyncDialog from "../util/confirmMatchDialog";
import ViewDetailsIcon from "../util/detailsModal/viewDetailsIcon";
import { sliceByEnv, getEnvColumnValue, getEnvRow, getRowDiff, mergeFields } from "../shared/envUtils";
import { useFetchOnMount } from "../../hooks/useFetchOnMount";

const columns = [
  {
    accessorKey: "CONNECTION_ID", //access nested data with dot notation
    header: "ID",
    size: 75,
  },
  {
    accessorKey: "CONNECTION_TYPE",
    header: "Type",
    size: 75,
  },
  {
    accessorKey: "PROJECT_ID", //access nested data with dot notation
    header: "Project ID",
    size: 75,
  },
  {
    accessorKey: "PROJECT_OID", //access nested data with dot notation
    header: "Project OID",
    size: 75,
  },
  {
    accessorKey: "PROJECT_NAME", //access nested data with dot notation
    header: "Project Name",
    size: 75,
  },
  {
    accessorKey: "SPONSOR_NAME", //access nested data with dot notation
    header: "Sponsor Name",
    size: 75,
  },
  {
    accessorKey: "BUSINESS_ID", //access nested data with dot notation
    header: "Business ID",
    size: 75,
  },
  {
    accessorKey: "CONNECTION_URL",
    header: "URL",
    size: 150,
  },
  {
    accessorKey: "CONNECTION_PROVIDER", //access nested data with dot notation
    header: "Provider",
    size: 100,
  },
  {
    accessorKey: "CONNECTION_DATA",
    header: "Data",
    size: 150,
  },
  {
    accessorKey: "AUTH_TYPE",
    header: "Auth Type",
    size: 150,
  },
  {
    accessorKey: "AUTH_ID",
    header: "Auth ID",
    size: 150,
  },
  {
    accessorKey: "AUTH_PIN",
    header: "Auth PIN",
    size: 150,
  },
  {
    accessorKey: "AUTH_PASSCODE",
    header: "Auth Passcode",
    size: 150,
  },
  {
    accessorKey: "STATE", //access nested data with dot notation
    header: "Status",
    size: 50,
  },
  {
    accessorKey: "MAX_ROWS_PER_QUERY",
    header: "Max Rows per Query",
    size: 150,
  },
  {
    accessorKey: "MAX_QUERIES",
    header: "Max Queries",
    size: 150,
  },
  {
    accessorKey: "PING_SERVICE",
    header: "Ping Service",
    size: 150,
  },
  {
    accessorKey: "COMMENTS", //access nested data with dot notation
    header: "Comments",
    size: 50,
  },
];

const EIConnections = () => {
  const {
    eiConnections,
    fetchEIConenctionsFromAllEnv,
    REACT_APP_ENV,
    envColumn1,
    envColumn2,
    openPromoteModal,
    setOpenPromoteModal,
    openDetailForm,
    editable,
    envCell,
    curRow,
    handleClickOpenDetail,
    handleDetailClose,
    onEditClick,
    handleClickOpen,
    handleClose,
    openMatchModal,
    setOpenMatchModal,
    matchCell,
    matchSelectedFields,
    setMatchSelectedFields,
    matchDirection,
    setMatchDirection,
    handleMatchClickOpen,
    handleMatchClose,
  } = useDataView();

  let currentEnvConfig = [];
  let envSlice = { current: [], dev: [], test: [], prod: [] };
  let detailData = null;

  const handleConfirm = () => {
    const payload = [
      {
        CONNECTION_ID: envCell.current.row.original.CONNECTION_ID,
        CONNECTION_TYPE: envCell.current.row.original.CONNECTION_TYPE,
        PROJECT_ID: envCell.current.row.original.PROJECT_ID,
        PROJECT_OID: envCell.current.row.original.PROJECT_OID,
        PROJECT_NAME: envCell.current.row.original.PROJECT_NAME,
        SPONSOR_NAME: envCell.current.row.original.SPONSOR_NAME,
        BUSINESS_ID: envCell.current.row.original.BUSINESS_ID,
        CONNECTION_URL: envCell.current.row.original.CONNECTION_URL,
        CONNECTION_PROVIDER: envCell.current.row.original.CONNECTION_PROVIDER,
        CONNECTION_DATA: envCell.current.row.original.CONNECTION_DATA,
        AUTH_TYPE: envCell.current.row.original.AUTH_TYPE,
        AUTH_ID: envCell.current.row.original.AUTH_ID,
        AUTH_PIN: envCell.current.row.original.AUTH_PIN,
        AUTH_PASSCODE: envCell.current.row.original.AUTH_PASSCODE,
        STATE: "Pending",
        MAX_ROWS_PER_QUERY: envCell.current.row.original.MAX_ROWS_PER_QUERY,
        MAX_QUERIES: envCell.current.row.original.MAX_QUERIES,
        PING_SERVICE: envCell.current.row.original.PING_SERVICE,
        COMMENTS: envCell.current.row.original.COMMENTS,
      },
    ];

    const env = envCell.current.column.id;
    const cmdCount = envCell.current.row.original.CmdCount;
    const connectionID = envCell.current.row.original.CONNECTION_ID;

    onSubmit(payload, env, cmdCount, connectionID);
    setOpenPromoteModal(false);
  };

  const onSubmit = (payload, env, cmdCount, connectionID) => {
    const resourcePath = "integrations/cfg/connections";

    API.AddRecordToOtherEnv(resourcePath, env, payload).then((response) => {
      if (response.code === 200) {
        const resourcePath =
          "integrations/cfg/transfer/" + connectionID + "/cmds";

        if (parseInt(cmdCount) > 0) {
          API.GetDataFromAPI(resourcePath).then((data) => {
            data.map((el) => {
              delete el["_pkTransferCmd"];
              delete el["pkTransferCmd"];
              delete el["CREATED_BY"];
              delete el["CREATED_TS"];
              return el;
            });

            if (data !== null) {
              API.AddRecordToOtherEnv(resourcePath, env, data).then(
                (response) => {
                  if (response.code === 200) {
                    NotificationManager.success(
                      "Record added to " + env + " env",
                      "EI Connection",
                      10000
                    );
                    fetchEIConenctionsFromAllEnv();
                  } else {
                    NotificationManager.error(
                      response.message,
                      "Only connection is promoted. Commands failed!",
                      10000
                    );
                  }
                }
              );
            }
          });
        } else {
          NotificationManager.success(
            "Record added to " + env + " env",
            "EI Connection",
            10000
          );
          fetchEIConenctionsFromAllEnv();
        }
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });
  };
  // Pulls the target env's field values into the current env's record.
  // Scoped to the connection record itself — nested commands aren't
  // copied by this action.
  const handleMatchConfirm = (fields, direction) => {
    const current = matchCell.current && matchCell.current.cell.row.original;
    const target = matchCell.current && matchCell.current.targetRow;

    if (!current || !target) {
      setOpenMatchModal(false);
      return;
    }

    // _CONNECTION_ID (leading underscore) is required by the backend
    // upsert to take the UPDATE branch instead of silently INSERTing a
    // duplicate — see mergeFields below: it's never in `fields`, so it
    // always comes from whichever row (current/target) is actually
    // being written to.
    const fieldNames = [
      "CONNECTION_ID", "CONNECTION_TYPE", "PROJECT_ID", "PROJECT_OID", "PROJECT_NAME",
      "SPONSOR_NAME", "BUSINESS_ID", "CONNECTION_URL", "CONNECTION_PROVIDER", "CONNECTION_DATA",
      "AUTH_TYPE", "AUTH_ID", "AUTH_PIN", "AUTH_PASSCODE", "STATE",
      "MAX_ROWS_PER_QUERY", "MAX_QUERIES", "PING_SERVICE", "COMMENTS", "_CONNECTION_ID",
    ];
    const isPush = direction === "push";
    const targetEnvLabel = matchCell.current.cell.column.id;
    const merged = isPush
      ? mergeFields(fieldNames, target, current, fields)
      : mergeFields(fieldNames, current, target, fields);
    const destEnv = isPush ? targetEnvLabel : REACT_APP_ENV;

    API.AddRecordToOtherEnv(
      "integrations/cfg/connections",
      destEnv,
      [merged]
    ).then((response) => {
      if (response.code === 200) {
        NotificationManager.success(
          isPush
            ? "Record synced to " + targetEnvLabel
            : "Record synced from " + targetEnvLabel,
          "EI Connection",
          10000
        );
        fetchEIConenctionsFromAllEnv();
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });

    setOpenMatchModal(false);
  };

  const customCellAction = makeEnvCellRenderer({
    openPromoteModal, envCell, handleClickOpen, handleClose, handleConfirm: (...args) => handleConfirm(...args),
    handleMatchClickOpen,
  });

  const mainColumns = [
    {
      accessorKey: "CONNECTION_ID", //access nested data with dot notation
      header: "ID",
      size: 300,
      Cell: viewDetails(),
    },
    {
      id: "CmdCount",
      accessorKey: "CmdCount", //normal accessorKey
      header: "CmdCount",
      size: 150,
      enableEditing: false,

      Cell: ({ row }) => {
        return (
          <Link to={"/ConnectionCommands/" + row.original._CONNECTION_ID}>
            {row.original.CmdCount}
          </Link>
        );
      },
    },
    {
      accessorKey: "STATE", //access nested data with dot notation
      header: "Status",
      size: 100,
      //Cell: handleStateAnimation(),
    },
    {
      accessorKey: "envColumn1",
      header: envColumn1,
      id: envColumn1,
      size: 150,
      Cell: customCellAction,
    },
    {
      accessorKey: "envColumn2", //access nested data with dot notation
      header: envColumn2,
      id: envColumn2,
      size: 150,
      Cell: customCellAction,
    },
  ];

  function viewDetails() {
    return function ({ cell, row }) {
      const cellValue = cell.getValue();
      const tooltip = "View Details";

      return (
        <>
          <ViewDetailsIcon
            row={row}
            tooltip={tooltip}
            onClick={handleClickOpenDetail}
          />
          {cellValue}

          <AppDialog
            open={openDetailForm}
            onClose={handleDetailClose}
            title="Connection Details"
            maxWidth="sm"
          >
            <ViewEditConnection
              curRow={curRow.current}
              handleDetailClose={handleDetailClose}
              editable={editable}
              onEditClick={onEditClick}
              data={detailData}
            />
          </AppDialog>
        </>
      );
    };
  }

  useFetchOnMount(eiConnections, fetchEIConenctionsFromAllEnv);

  if (eiConnections.length > 0) {
    envSlice = sliceByEnv(eiConnections, REACT_APP_ENV);
    currentEnvConfig = envSlice.current;

    detailData = currentEnvConfig.map((connection) => {
      return {
        _CONNECTION_ID: connection._CONNECTION_ID,
        CONNECTION_ID: connection.CONNECTION_ID,
        CONNECTION_TYPE: connection.CONNECTION_TYPE,
        PROJECT_ID: connection.PROJECT_ID,
        PROJECT_OID: connection.PROJECT_OID,
        PROJECT_NAME: connection.PROJECT_NAME,
        SPONSOR_NAME: connection.SPONSOR_NAME,
        BUSINESS_ID: connection.BUSINESS_ID,
        CONNECTION_URL: connection.CONNECTION_URL,
        CONNECTION_PROVIDER: connection.CONNECTION_PROVIDER,
        CONNECTION_DATA: connection.CONNECTION_DATA,
        AUTH_TYPE: connection.AUTH_TYPE,
        AUTH_ID: connection.AUTH_ID,
        AUTH_PIN: connection.AUTH_PIN,
        AUTH_PASSCODE: connection.AUTH_PASSCODE,
        STATE: connection.STATE,
        MAX_ROWS_PER_QUERY: connection.MAX_ROWS_PER_QUERY,
        MAX_QUERIES: connection.MAX_QUERIES,
        PING_SERVICE: connection.PING_SERVICE,
        COMMENTS: connection.COMMENTS,
        CmdCount: connection._cmdCount_,
      };
    });
  }

  let loading = false;
  if (currentEnvConfig.length === 0) {
    loading = true;
  } else {
    loading = false;
  }

  if (Boolean(loading)) {
    return <ShowLoadingBar title="LIST of CONNECTIONS" loading={loading} />;
  }

  return (
    <div className="cache-table">

      {currentEnvConfig.length > 0 && (
        <EIConnectionViewTable
          data={currentEnvConfig.map((connection) => {
            const _CONNECTION_ID = connection._CONNECTION_ID;
            const col1 = getEnvColumnValue({ envColumn: envColumn1, ...envSlice, idKey: "_CONNECTION_ID", idValue: _CONNECTION_ID });
            const col2 = getEnvColumnValue({ envColumn: envColumn2, ...envSlice, idKey: "_CONNECTION_ID", idValue: _CONNECTION_ID });
            const targetRow1 = getEnvRow({ envColumn: envColumn1, ...envSlice, idKey: "_CONNECTION_ID", idValue: _CONNECTION_ID });
            const targetRow2 = getEnvRow({ envColumn: envColumn2, ...envSlice, idKey: "_CONNECTION_ID", idValue: _CONNECTION_ID });

            return {
              _CONNECTION_ID: connection._CONNECTION_ID,
              CONNECTION_ID: connection.CONNECTION_ID,
              CONNECTION_TYPE: connection.CONNECTION_TYPE,
              PROJECT_ID: connection.PROJECT_ID,
              PROJECT_OID: connection.PROJECT_OID,
              PROJECT_NAME: connection.PROJECT_NAME,
              SPONSOR_NAME: connection.SPONSOR_NAME,
              BUSINESS_ID: connection.BUSINESS_ID,
              CONNECTION_URL: connection.CONNECTION_URL,
              CONNECTION_PROVIDER: connection.CONNECTION_PROVIDER,
              CONNECTION_DATA: connection.CONNECTION_DATA,
              AUTH_TYPE: connection.AUTH_TYPE,
              AUTH_ID: connection.AUTH_ID,
              AUTH_PIN: connection.AUTH_PIN,
              AUTH_PASSCODE: connection.AUTH_PASSCODE,
              STATE: connection.STATE,
              MAX_ROWS_PER_QUERY: connection.MAX_ROWS_PER_QUERY,
              MAX_QUERIES: connection.MAX_QUERIES,
              PING_SERVICE: connection.PING_SERVICE,
              COMMENTS: connection.COMMENTS,
              CmdCount: connection._cmdCount_,
              envColumn1: col1,
              envColumn2: col2,
              [`${envColumn1}__diff`]: { ...getRowDiff(connection, targetRow1), targetRow: targetRow1 },
              [`${envColumn2}__diff`]: { ...getRowDiff(connection, targetRow2), targetRow: targetRow2 },
            };
          })}
          columns={columns}
          mainColumns={mainColumns}
        />
      )}

      <SyncDialog
        open={openMatchModal}
        matchCell={matchCell}
        matchSelectedFields={matchSelectedFields}
        setMatchSelectedFields={setMatchSelectedFields}
        matchDirection={matchDirection}
        setMatchDirection={setMatchDirection}
        handleMatchClose={handleMatchClose}
        handleMatchConfirm={(...args) => handleMatchConfirm(...args)}
      />
    </div>
  );
};

export default EIConnections;
